import React from "react";
import { AspectRatio, Box } from "@chakra-ui/react";
import { horizontalContainerPadding } from "ui/container";
import { FillImage } from "components/images";
import product from "../../../../public/assets/platform/agents/product.png";

export function AgentsMobileProductImage() {
  return (
    <Box display={{ lg: "none" }} pos="relative" zIndex={2} overflow="hidden" mb="smallest">
      <Box pl={horizontalContainerPadding} pos="relative">
        <AspectRatio ratio={408 / 300}>
          <FillImage src={product} alt="Hightouch Agents product interface" placeholder="empty" />
        </AspectRatio>

        <Box
          pos="absolute"
          bottom={0}
          left={0}
          width="150%"
          height={{ base: "200px", md: "300px" }}
          zIndex={10}
          bg="linear-gradient(to top, white 25%, transparent)"
        />
      </Box>
    </Box>
  );
}
